import { EmployerConstants } from '../store/employer.constants'

export const employerSchemas = [
  {
    inputKey: EmployerConstants.SET_PRIMARY_BUSINESS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PRIMARY_BUSINESS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PRIMARY_BUSINESS'],
    errorMessage: {
      properties: {
        SET_PRIMARY_BUSINESS: 'Must be alphanumeric with max length of 100',
      },
    },
  },

  {
    inputKey: EmployerConstants.SET_ADDRESS1,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS1: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS1'],
    errorMessage: {
      properties: {
        SET_ADDRESS1: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: EmployerConstants.SET_ADDRESS2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS2: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS2'],
    errorMessage: {
      properties: {
        SET_ADDRESS2: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: EmployerConstants.SET_ZIPCODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ZIPCODE: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_ZIPCODE'],
    errorMessage: {
      properties: {
        SET_ZIPCODE: 'Must be in the format: NNNNN or NNNNN-NNNN',
      },
    },
  },

  {
    inputKey: EmployerConstants.SET_CITY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CITY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,30}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CITY'],
    errorMessage: {
      properties: {
        SET_CITY: 'Must be alphanumeric with max length of 30',
      },
    },
  },

  {
    inputKey: EmployerConstants.SET_PHONENUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHONENUMBER: {
        type: 'string',
        pattern: '^([2-9][0-9][0-9]-[2-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHONENUMBER'],
    errorMessage: {
      properties: {
        SET_PHONENUMBER: 'Must be in the format: NNN-NNN-NNNN',
      },
    },
  },
]
